import React from 'react';
import workerImage from '../../assets/african-american-worker-her-coworker-reading-order-list-before-shipment-while-working-warehouse.jpg'; // Replace with actual image path
import { FaAnchor } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import './About.css';


const handleRipple = (e) => {
  const button = e.currentTarget;
  const circle = document.createElement('span');

  const diameter = Math.max(button.clientWidth, button.clientHeight);
  const radius = diameter / 2;
  const rect = button.getBoundingClientRect();

  circle.style.width = circle.style.height = `${diameter}px`;
  circle.style.left = `${e.clientX - rect.left - radius}px`;
  circle.style.top = `${e.clientY - rect.top - radius}px`;
  circle.classList.add('ripple');

  // Remove old ripple
  const oldRipple = button.querySelector('.ripple');
  if (oldRipple) oldRipple.remove();

  button.appendChild(circle);
};
const AboutSection = () => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate('/aboutPage'); // Navigates to /profile
  };

  return (
    <section className="about-section">
      <div className="about-top">
        <div className="text-content">
          <p className="label">ABOUT US</p>
          <h2 className="heading">
            POWERING INDUSTRIES<br />
            WITH RELIABLE<br />
            LOGISTICS SOLUTIONS
          </h2>
          <ul className="description">
            <li>Vedant Enterprise is a reputed name in the industrial supply industry, known for its commitment to quality, performance, and reliability.</li>
            {/* <li>We provide a broad range of industrial components like valves, fittings, fasteners, and pneumatic products — designed to meet diverse client needs with technical precision.</li> */}
            <li>Backed by a team of experienced professionals and trusted vendor associations, we ensure timely delivery and service excellence.</li>
          </ul>
          <button className="learn-more" onMouseEnter={handleRipple} onClick={handleClick}>LEARN MORE</button>
        </div>

        <div className="image-section">
          <div className="badge-main">
            <div className="badge-anchor">
              <FaAnchor />
            </div>
            <div className="badge">

              <div className="badge-text">
                <h3>200+</h3>
                <div className="badge-label">SKILLED WORKERS</div>
              </div>
            </div>
          </div>
        </div>

      </div>

      <div className="cards-section">
        <div className="card" >
          <div className="card-number">01</div>
          <div className="card-divider"></div>
          <div className="card-text">
            WIDE-SCALE <br /> LOGISTICS NETWORK
          </div>
        </div>
        <div className="card" >
          <div className="card-number">02</div>
          <div className="card-divider"></div>
          <div className="card-text">
            RELIABLE & SCALABLE <br /> OPERATIONS
          </div>
        </div>
        <div className="card" >
          <div className="card-number">03</div>
          <div className="card-divider"></div>
          <div className="card-text">
            CUSTOMER-<br />CENTRIC SERVICE
          </div>
        </div>
      </div>

    </section >
  );
};

export default AboutSection;
